import React from "react";
import { OverlayPanel } from "primereact/overlaypanel";
import styles from "./index.module.scss";
import NotificationBody from "./notification-body";

export default function NotificationModel({
  popRef
}: {
  popRef: React.RefObject<OverlayPanel>;
}) {
  React.useEffect(() => {
    const handleScroll = () => {
      const inst: any = popRef?.current;
      if (!inst) return;
      try {
        const el = typeof inst.getElement === "function" ? inst.getElement() : inst?.container || inst?.overlay || null;
        if (!el) return;
        if (typeof inst.hide === "function") inst.hide();
      } catch (_) {
        // no-op
      }
    };
    window.addEventListener("scroll", handleScroll, { passive: true });
    window.addEventListener("resize", handleScroll, { passive: true });
    return () => {
      window.removeEventListener("scroll", handleScroll);
      window.removeEventListener("resize", handleScroll);
    };
  }, [popRef]);

  return (
    <OverlayPanel
      ref={popRef}
      className={styles.NotificationModel}
    >
      <NotificationBody />
    </OverlayPanel>
  );
}
